var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.29 5.89002L11.29 15.89C10.9 16.28 10.27 16.28 9.88001 15.89L7.05001 13.06C6.66001 12.67 6.66001 12.04 7.05001 11.65C7.44001 11.26 8.07001 11.26 8.46001 11.65L10.58 13.77L19.87 4.48002C20.26 4.09002 20.89 4.09002 21.28 4.48002C21.68 4.87002 21.68 5.50002 21.29 5.89002ZM15.77 2.74002C14.08 2.05002 12.16 1.81002 10.16 2.17002C6.09001 2.90002 2.84001 6.18002 2.15001 10.25C1.01001 17 6.63001 22.78 13.34 21.91C17.3 21.4 20.62 18.45 21.66 14.6C22.06 13.13 22.1 11.71 21.87 10.38C21.74 9.58002 20.75 9.27002 20.17 9.84002C19.94 10.07 19.84 10.41 19.9 10.73C20.12 12.06 20.02 13.48 19.38 14.99C18.22 17.7 15.7 19.69 12.77 19.96C7.67001 20.43 3.44001 16.11 4.07001 10.98C4.50001 7.44002 7.35001 4.56002 10.88 4.07002C12.61 3.83002 14.25 4.16002 15.65 4.88002C16.04 5.08002 16.51 5.01002 16.82 4.70002C17.3 4.22002 17.18 3.41002 16.58 3.10002C16.31 2.98002 16.04 2.85002 15.77 2.74002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTask);
export default __webpack_public_path__ + "static/media/ico-task.b302a358dd57a3fcaeaa13be0513df94.svg";
export { ForwardRef as ReactComponent };